import React, { useState, FormEvent, FC, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { register } from "../../store/actions/auth";
import { firestore, Auth } from "../../firebase";
import { auth } from "firebaseui";
import { User } from "../../models/user";
import { uiConfig } from "./auth";

interface Props {
  register: Function;
}

const Register: FC<Props> = ({ register }) => {
  let mounted: boolean = true;
  document.getElementsByTagName("title")[0].innerHTML = "register";
  const accTypes = ["fan", "artist"];
  const [userData, setUserdata] = useState({
    username: "",
    email: "",
    accountType: "fan",
    password: "",
    password1: "",
  });
  const [feedback, setfeedback] = useState("");

  const onChange = (e: FormEvent<HTMLInputElement | HTMLSelectElement>) => {
    if (mounted) {
      setUserdata({
        ...userData,
        [e.currentTarget.id]: e.currentTarget.value,
      });
    }
  };

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const { username, email, password, password1, accountType } = userData;
    if (!username) {
      if (mounted) setfeedback("Username is required");
    } else if (username.match(/\W/)) {
      if (mounted) {
        setfeedback(
          "Invalid character, Username should include letters, underscore and numbers only",
        );
      }
    } else if (!email) {
      if (mounted) setfeedback("Email is required");
    } else if (!email.includes("@")) {
      if (mounted) setfeedback("Please enter a valid email");
    } else if (!password) {
      if (mounted) setfeedback("Password is required");
    } else if (password.length < 6) {
      if (mounted) setfeedback("Password must be 6 or more characters");
    } else if (password !== password1) {
      if (mounted) setfeedback("Passwords don't match");
    } else {
      const user = {
        username,
        email,
        password,
        accountType,
        firstName: "",
        lastName: "",
        location: "",
        bio: "",
      };
      let fb = await register(user);
      if (mounted) setfeedback(fb);
    }

    if (mounted) setTimeout(() => setfeedback(""), 6000);
  };

  useEffect(() => {
    // Initialize the FirebaseUI Widget using Firebase.
    // var ui = new auth.AuthUI(Auth());

    if (auth.AuthUI.getInstance()) {
      const ui = auth.AuthUI.getInstance()!;
      ui.start("#auth", uiConfig);
    } else {
      const ui = new auth.AuthUI(Auth());
      ui.start("#auth", uiConfig);
    }

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      mounted = false;
    };
  });

  return (
    <div
      className="uk-margin-auto uk-width-2-5@m uk-margin-large-top uk-width-1-1@s"
    >
      <form
        onSubmit={onSubmit}
        className="uk-card form uk-padding uk-border-rounded uk-margin-auto"
      >
        <h3 className="">Register</h3>
        <div className="uk-margin-small-bottom">
          <label className="uk-form-label">Username</label>
          <input
            onChange={onChange}
            onKeyUp={(e) => {
              if (e.currentTarget.value.match(/\W/)) {
                setfeedback(
                  "Invalid character, Username should include letters, underscore and numbers only",
                );
              } else {
                setfeedback("");
              }
            }}
            type="text"
            id="username"
            className="uk-input"
            placeholder="Username"
          />
        </div>
        <div className="uk-margin-small-bottom">
          <label className="uk-form-label">Email</label>
          <input
            onChange={onChange}
            type="email"
            className="uk-input"
            id="email"
            placeholder="Email"
          />
        </div>
        <div className="uk-margin-small-bottom">
          <label className="uk-form-label">I am</label>
          <select id="accountType" onChange={onChange} className="uk-select">
            {accTypes &&
              accTypes.map((type) => {
                return (
                  <option key={type} value={type}>
                    {type}
                  </option>
                );
              })}
          </select>
        </div>

        <div className="uk-margin-small-bottom">
          <label className="uk-form-label">Password</label>
          <input
            onChange={onChange}
            id="password"
            type="password"
            className="uk-input"
            placeholder="Password"
          />
        </div>
        <div className="uk-margin-small-bottom">
          <label className="uk-form-label">Repeat Password</label>
          <input
            onChange={onChange}
            type="password"
            id="password1"
            className="uk-input"
            placeholder="Password"
          />
        </div>
        {feedback && (
          <div
            style={{
              background: "red",
              padding: "8px",
              color: "white",
              width: "100%",
              fontWeight: "bold",
            }}
          >
            {feedback}
          </div>
        )}
        <div id="auth"></div>
        <div className="uk-margin-small-top uk-flex-center">
          <button
            className="uk-button uk-border-rounded"
            style={{ color: "#000" }}
          >
            Register
          </button>
        </div>
        <div className="uk-margin-small-top" style={{ color: "#000" }}>
          Have an account? <Link to="/login">Login</Link>
        </div>
      </form>
    </div>
  );
};

export default connect(null, { register })(Register);
